// extracted by mini-css-extract-plugin
export default {"filter_mobile_language_content":"LanguageMobileScreen_filter_mobile_language_content__oRjNS","checkboxList":"LanguageMobileScreen_checkboxList__lKjOY"};